export const UploadPmpMonitoringReportFailStage = {
  Filename: "Filename",
  ExcelParse: "ExcelParse",
  MissingColumns: "MissingColumns",
  DuplicateIds: "DuplicateIds",
  DataError: "DataError",
  System: "System",
} as const;

export type UploadPmpMonitoringReportFailStage =
  (typeof UploadPmpMonitoringReportFailStage)[keyof typeof UploadPmpMonitoringReportFailStage];

export interface UploadPmpMonitoringReportParams {
  metric: string;
  auditingPeriod: string;
  file: File;
  userId: string;
}

export interface UploadPmpMonitoringReportResponse {
  success: boolean;
  messages: string[];
  statusCode: number;
  failStage: UploadPmpMonitoringReportFailStage | null;
  /** Upload-log row ID to poll while the save runs in the background; null/absent when the response is terminal. */
  logId?: string | null;
}

export const UploadLogStatus = {
  Failed: 0,
  Success: 1,
  Processing: 2,
} as const;

export type UploadLogStatus = (typeof UploadLogStatus)[keyof typeof UploadLogStatus];

export interface GetPmpMonitoringReportUploadResultParams {
  logId: string;
}

export interface GetPmpMonitoringReportUploadResultResponse {
  found: boolean;
  status: number | null;
  messages: string[];
}
